import { FunctionComponent, useCallback } from 'react'
import config from '@config'
import Script from 'next/script'
import { initGoogleNewsShowcase } from './utils'
import { useQueryClient } from '@tanstack/react-query'
import useIsPianoSDKLoaded from '@hooks/useIsPianoSDKLoaded'
import useHasPianoSDKErrored from '@hooks/useHasPianoSDKErrored'
import { getLoginUrl } from '@hooks/useAuthentication/utils'
import useURLParam from '@hooks/useURLParam'
import { getCurrentGNSUserState } from '@hooks/useGnsStateUser'

const {
  gns: { gnsGsiClientUrl, gnsSwgGaaUrl, gnsSwgUrl },
} = config

const GnsManager: FunctionComponent = () => {
  const queryClient = useQueryClient()

  const hasGoogleShowcaseParam = !!useURLParam('gaa_sig')

  const onGnsSDKLoaded = useCallback(() => {
    const authorizationUrl = getLoginUrl({
      queryClient,
      sourcePrefix: 'GNS',
      loginCase: 'email_only',
      omitPublicationInSource: true,
      googleLogin: true,
    })

    initGoogleNewsShowcase({
      userState: getCurrentGNSUserState(queryClient),
      authorizationUrl,
      queryClient,
    })
  }, [queryClient])

  return [
    hasGoogleShowcaseParam,
    [useHasPianoSDKErrored(), useIsPianoSDKLoaded()].some(Boolean),
  ].every(Boolean) ? (
    <>
      <Script
        id="GnsGsiClient"
        src={gnsGsiClientUrl}
        strategy="afterInteractive"
        defer={true}
      />
      <Script
        id="GnsSwg"
        strategy="afterInteractive"
        subscriptions-control="manual"
        src={gnsSwgUrl}
        defer={true}
      />
      <Script
        id="GnsSwgGaa"
        strategy="afterInteractive"
        src={gnsSwgGaaUrl}
        defer={true}
        onLoad={onGnsSDKLoaded}
      />
    </>
  ) : null
}

export default GnsManager
